<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-form-group :label="$t('name')">
                    <b-input-group :prepend="$t('variable_language')">
                        <div class="label-as-input">{{ isNotNullValue(form.name) }}</div>
                    </b-input-group>
                    <b-input-group class="mt-2" prepend="EN">
                        <div class="label-as-input">{{ isNotNullValue(form.name_en) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group :label="$t('code')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.code) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group :label="$t('status')">
                    <b-input-group>
                        <div class="label-as-input">{{ getStatusText(form.status) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    //Service
    import ExcelExportCrudService from "@/services/ExcelExportCrudService";

    export default {
        props: {
            formId: {
                type: Number,
            }
        },
        data() {
            return {
                form: {
                    code: null,
                    name: null,
                    name_en: null,
                    status: null,
                }
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                ExcelExportCrudService.get(id)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.form.status = this.form.status == 1 ? 'a' : 'p';
                                })
                                .catch((error) => {
                                    this.showErrors(error)
                                })
            },

        }
    }
</script>
